import { withTheme } from '@material-ui/core/styles';
import styled, { css } from 'styled-components';

export const WrapperLog = withTheme(styled.div`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #fff;
    border-radius: 0.6rem;
    padding: 5rem;
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);

    form > div {
      margin-bottom: 3.7rem;
    }

    input {
      color: #666;
      font-family: 'Poppins', sans-serif;
    }

    p {
      color: #666;
      margin-top: 2rem;
    }

    a {
      color: ${theme.palette.primary.dark};
      font-weight: 500;
    }

    button {
      height: 5rem;
      border-radius: 2.5rem;
      border: none;
      background-image: linear-gradient(
        to right,
        ${theme.palette.primary.dark},
        ${theme.palette.primary.main},
        ${theme.palette.primary.dark}
      );
      background-size: 200%;
      font-size: 1.5rem;
      transition: 0.5s;
    }

    button:hover {
      background-position: right;
    }

    @media (max-width: 768px) {
      padding: 2rem 5rem;

      img {
        margin-bottom: 1.5rem;
      }

      form > div {
        margin-bottom: 1rem;
      }

      p {
        margin-top: 1.5rem;
      }

      button {
        margin-top: 2rem;
      }
    }
  `}
`);
